class InteractiveGradientCursor extends HTMLElement {
  constructor() {
    super();
    this.curX = 0;
    this.curY = 0;
    this.tgX = 0;
    this.tgY = 0;
    this.interBubble = null;
    this.isInitialized = false;
    this._animId = null;
    this._visible = true;
  }

  connectedCallback() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.init(), {
        once: true,
      });
    } else {
      this.init();
    }
  }

  init() {
    if (this.isInitialized) return;
    this.interBubble = this.querySelector(".interactive");
    if (!this.interBubble) return;

    this.interBubble.style.willChange = "transform";
    this.interBubble.style.transform = "translate3d(0,0,0)";
    this.interBubble.style.pointerEvents = "none";
    this.interBubble.style.position = "absolute";
    this.interBubble.style.zIndex = "9999";

    const io = new IntersectionObserver(
      (entries) => {
        const v = entries[0]?.isIntersecting ?? true;
        this._visible = v;
        if (v) this._start();
        else this._stop();
      },
      { root: null, threshold: 0 }
    );
    io.observe(this);

    this.addEventListeners();
    this.isInitialized = true;
    this._start();
  }

  _start() {
    if (this._animId) return;
    const move = () => {
      if (!this._visible || !this.interBubble) {
        this._animId = requestAnimationFrame(move);
        return;
      }

      this.curX += (this.tgX - this.curX) / 20;
      this.curY += (this.tgY - this.curY) / 20;

      const nx = Math.round(this.curX);
      const ny = Math.round(this.curY);
      if (this._lastX !== nx || this._lastY !== ny) {
        this.interBubble.style.transform = `translate3d(${nx}px, ${ny}px, 0)`;
        this._lastX = nx;
        this._lastY = ny;
      }

      this._animId = requestAnimationFrame(move);
    };
    this._animId = requestAnimationFrame(move);
  }

  _stop() {
    if (this._animId) cancelAnimationFrame(this._animId);
    this._animId = null;
  }

  addEventListeners() {
    window.addEventListener(
      "pointermove",
      (e) => {
        this.tgX = e.clientX;
        this.tgY = e.clientY;
      },
      { passive: true }
    );

    window.addEventListener(
      "pointerdown",
      (e) => {
        this.tgX = e.clientX;
        this.tgY = e.clientY;
      },
      { passive: true }
    );
  }

  disconnectedCallback() {
    this._stop();
  }
}

customElements.define("interactive-gradient-cursor", InteractiveGradientCursor);
